export const datesQueryFactory = (from, timeRange, sportId) => {
    return {
        id: sportId,
        eventState: "PreLive",
        dateRange: {
            from,
            timeRange
        }
    };
};
//# sourceMappingURL=DatesQueries.js.map